import { IconButton, useColorMode } from '@chakra-ui/react';
import { FiMoon, FiSun } from 'react-icons/fi';
import { useThemeStore } from '../../../core/theme/ThemeProvider';
import { Theme } from '../../../core/types/ui/theme';
import { MdDarkMode } from 'react-icons/md';

const ThemeSwitch = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const { activeTheme, setTheme } = useThemeStore();

  const toggleTheme = () => {
    let newTheme = Theme.Dark;
    if (activeTheme === Theme.Dark) newTheme = Theme.Light;
    toggleColorMode();
    setTheme(newTheme);
  };

  return (
    <IconButton
      size="sm"
      mr={1}
      ml={1}
      borderRadius="50%"
      icon={colorMode === 'light' ? <FiMoon size="16px" /> : <FiSun size="16px" />}
      onClick={toggleTheme}
      aria-label="Toggle dark theme"
    />
  );
};

export default ThemeSwitch;
